import DISPLAY from 'constants/display'
import { ICarrierOptionCarrier } from '../types'

export const getCarrierAutocompleteOptionText = ({
  dotNumber,
  mcNumber,
  name,
}: ICarrierOptionCarrier) =>
  `MC ${mcNumber || DISPLAY.empty} · DOT ${dotNumber || DISPLAY.empty} · ${name || DISPLAY.empty}`
